module.exports = __webpack_public_path__ + "img/ab-logo.b3b036be.png";